import {
  Box, HoverHintWrapper, ListItem, Text,
} from '@domain-group/suit-theme'

import ColouredCircle from '@components/ColouredCircle'

import useSelector from '@hooks/useSelector'
import useStatus from '@hooks/useStatus'

type InspectionListItemProps = {
  inspectionId: number,
}

const InspectionListItem = (props: InspectionListItemProps) => {
  const { inspectionId } = props

  const { campaigns, publicationInspections } = useSelector(reduxState => reduxState.entities)

  const publicationInspection = publicationInspections[inspectionId] || {}
  const { campaign_id, status_id } = publicationInspection

  const campaign = campaigns[campaign_id] || {}

  const { status } = useStatus({ id: status_id })
  // @ts-expect-error TS2339
  const backgroundColor = status.key === 'approved' ? 'green' : ''

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{ borderBottom: '1px dashed', minHeight: '51px' }}
      disableHover
      // @ts-expect-error TS2322
      fontSize="small"
      padding="large"
    >
      <Box paddingX="large">
        <Box alignItems="center" fontSize="small" maxWidth={['100%', '60%']}>
          <HoverHintWrapper
            height={16}
            // @ts-expect-error TS2339
            hintComponent={<HoverHintWrapper.Hint>{status.title}</HoverHintWrapper.Hint>}
            width={16}
          >
            <ColouredCircle backgroundColor={backgroundColor} />
          </HoverHintWrapper>

          <Text marginLeft="large" variant="ellipsis">{campaign.title}</Text>
        </Box>

        <Box
          alignItems="center"
          display={['none', 'flex']}
          fontSize="small"
          justifyContent="flex-end"
          maxWidth="40%"
        >
          <Text color="bodyFontLightColor" verticalAlign="middle" variant="ellipsis">
            {publicationInspection.inspection_details}
          </Text>
        </Box>
      </Box>
    </ListItem>
  )
}

export default InspectionListItem
